import { axiosClient } from '@nx-frontend/shared/api';
import { WorkspaceMemberDto } from '@nx-frontend/shared/types';

export async function clientGetWorkspaceMembers(workspaceId: string): Promise<WorkspaceMemberDto[]> {
  if (!workspaceId) return [];
  try {
    const response = await axiosClient.get<WorkspaceMemberDto[]>(`/v2/api/workspaces/${workspaceId}/members`);
    return response.data;
  } catch (err) {
    console.log(`[clientGetOrgWorkspaceMembers] error: ${err}`);
  }
  return [];
}
